
  
  
  const googleAuth = (WrappedComponent) => {
    const WrapperComponent = (props) => {
      const clientId = '597451907450-maqvlcf6g5fn4cf6n1012ftbfq621mmu.apps.googleusercontent.com';
  
      const signInUser = async (cb) => {
          if(!cb) { return; }
        let googleAuthObj;
        if (window.gapi) {
          window.gapi.load("auth2", async () => {
            try {
              googleAuthObj = await window.gapi.auth2.init({
                client_id: clientId,
              });
              const googleUser = await googleAuthObj.signIn();
              const { id_token } = await googleUser.getAuthResponse();
              cb(null, id_token);
            } catch (error) {
              cb(error, null);
            }
          });
        }
      };

  
      return (
        <>
          <WrappedComponent
            googleAuthHandler={signInUser}
            {...props}
          />
        </>
      );
    };
  
    return WrapperComponent;
  };
  
  
  export default googleAuth;
  